import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { groupService, authService } from '../../services/api';

/**
 * Página para criar novo grupo com design moderno.
 */
const CreateGroupPage = () => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const newGroup = await groupService.create({
        ...formData,
        createdById: user.userId,
      });
      navigate(`/groups/${newGroup.id}`);
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao criar grupo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: 32 }}>
          <Link 
            to="/groups" 
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: 8, 
              color: 'var(--text-secondary)',
              marginBottom: 16,
              fontSize: 14
            }}
          >
            <i className="fa-solid fa-arrow-left"></i> Voltar para grupos
          </Link>
          <h1 className="page-title">
            <i className="fa-duotone fa-sparkles page-title-icon"></i>
            Criar Novo Grupo
          </h1>
          <p style={{ color: 'var(--text-secondary)', marginTop: 8 }}>
            Crie um grupo para começar a dividir despesas com seus amigos
          </p>
        </div>

        {/* Form Card */}
        <div className="card-modern animate-fadeIn">
          <div className="card-modern-body">
            {/* Error */}
            {error && (
              <div className="alert alert-error">
                <i className="fa-solid fa-triangle-exclamation"></i>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Nome do grupo *</label>
                <input
                  type="text"
                  name="name"
                  className="form-input"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Ex: Viagem para praia, Almoço do trabalho..."
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Descrição (opcional)</label>
                <textarea
                  name="description"
                  className="form-input"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Descreva o propósito do grupo..."
                  rows={4}
                  style={{ resize: 'vertical' }}
                />
              </div>

              <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate('/groups')}
                  disabled={loading}
                  style={{ flex: 1 }}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                  style={{ flex: 2 }}
                >
                  {loading ? (
                    <>
                      <i className="fa-solid fa-spinner fa-spin"></i>
                      Criando...
                    </>
                  ) : (
                    <>
                      Criar Grupo
                      <i className="fa-solid fa-arrow-right"></i>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateGroupPage;
